<template>
  <div class="subjectDetails">
    <div class="topTitle">
      <el-page-header @back="goback" :content="$route.query.title">
      </el-page-header>
    </div>

    <el-row style="background:#f1f7fe;margin:10px;">
      <el-col :span="16">
        <div
          class="timu_desc"
          style="background:white;padding:10px 20px 20px 20px;border-radius:5px;margin-right:10px;"
        >
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="比赛简介" name="first">
              <div v-if="is_md">
                <mavon-editor
                  class="bisai_desc"
                  preview-background="#fff"
                  v-model="contentMain.description"
                  defaultOpen="preview"
                  :boxShadow="false"
                  :editable="false"
                  :subfield="false"
                  :toolbarsFlag="false"
                ></mavon-editor>
              </div>
              <div
                v-else
                v-html="formatRichText(contentMain.description)"
              ></div>
            </el-tab-pane>
            <el-tab-pane label="比赛题目" name="second" v-if="isShow">
              <el-table
                :data="tableData3"
                stripe
                style="width: 100%;"
                :header-cell-style="{
                  background: '#f5f7fa',
                  color: '#606266',
                  'font-size': '14px',
                }"
              >
                <el-table-column type="index" label="序号" width="80">
                  <template slot-scope="scope">
                    <span>{{
                      scope.$index + 1 + (page_no - 1) * page_size
                    }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="problemInfo.code"
                  label="题号"
                  width="100"
                >
                </el-table-column>

                <el-table-column prop="problemInfo.title" label="题目名称">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="mini"
                      @click="goNext(scope.row)"
                      >{{ scope.row.problemInfo.title }}</el-button
                    >
                  </template>
                </el-table-column>

                <!-- <el-table-column prop="problemInfo.title" label="题库链接" v-if="isShow2">
                  <template slot-scope="scope">
                    <span v-if="scope.row.problemInfo != null && scope.row.problemInfo.is_public ? true : false">
                      <el-button type="text" size="mini" @click="goNext1(scope.row)" :disabled="disabled2">
                        题库链接
                      </el-button>
                    </span>
                  </template>
                </el-table-column> -->

                <el-table-column label="状态" width="150">
                  <template slot-scope="scope">
                    <span v-if="scope.row.stats === '1'">
                      已提交
                    </span>
                    <span v-else>
                      <div
                        style=" font-size: 14px;"
                        class="el-icon-minus"
                      ></div>
                    </span>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin: 20px; text-align: right">
                <el-pagination
                  @current-change="handleCurrent"
                  :current-page="page_no"
                  :page-size="page_size"
                  layout="total, prev, pager, next, jumper"
                  :total="total"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="比赛排行" name="third" v-if="isShow">
              <el-table
                :data="tableData1"
                stripe
                style="width: 100%;"
                :header-cell-style="{
                  background: '#f5f7fa',
                  color: '#606266',
                  'font-size': '14px',
                }"
              >
                <el-table-column type="index" label="名次"> </el-table-column>
                <el-table-column width="100" label="头像" align="center">
                  <template slot-scope="scope">
                    <el-image
                      style="width: 30px; height: 30px"
                      :src="scope.row.headImgUrl"
                      fit="cover"
                    ></el-image>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="realname"
                  label="参赛者"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.stu_user_id === null">{{
                      scope.row.realname
                    }}</span>
                    <span v-else>{{ scope.row.realname }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="ac_problem_num"
                  label="通过"
                  v-if="contentMain.rule_type === 1 ? true : false"
                >
                </el-table-column>

                <el-table-column
                  prop="score"
                  :label="contentMain.rule_type === 1 ? '耗时' : '总分'"
                >
                  <template slot-scope="scope">
                    <span v-if="contentMain.rule_type === 1">
                      {{
                        Math.floor(scope.row.total_cost_time / 60) +
                          ':' +
                          ((scope.row.total_cost_time % 60) / 100)
                            .toFixed(2)
                            .slice(-2)
                      }}
                    </span>
                    <span v-else>
                      <div>{{ scope.row.score }}</div>
                      <div>({{ scope.row.total_cpu_time }})ms</div>
                    </span>
                  </template>
                </el-table-column>
                <template>
                  <el-table-column
                    v-for="(item, index) in tableData"
                    :label="'#' + (index + 1 + '')"
                    :key="index + 1"
                  >
                    <template slot-scope="scope">
                      <span
                        v-for="(item1, index1) in JSON.parse(
                          scope.row.submission_info
                        )"
                        :key="index1"
                      >
                        <span
                          v-if="
                            item1.problemId === item.oj_problem_id &&
                              contentMain.rule_type === 1
                          "
                        >
                          <!-- @click="searchProblem(item1)" -->
                          <!-- <div>
                        <span style="color:blue;cursor: pointer;">{{item1.costTime}}</span> ({{item1.beforeRightSubmissionNum}})
                      </div> -->
                          <div v-if="item1.result != 0">
                            <div style="color:#f00;font-weight:bold">
                              -{{ item1.beforeRightSubmissionNum }}
                            </div>
                            <div>00:00</div>
                          </div>
                          <div v-else>
                            <div v-if="item1.beforeRightSubmissionNum === 0">
                              <div
                                style="color:#52C41A;font-weight:bold"
                                class="el-icon-check"
                              ></div>
                              <div>
                                {{
                                  Math.floor(item1.costTime / 60) +
                                    ':' +
                                    ((item1.costTime % 60) / 100)
                                      .toFixed(2)
                                      .slice(-2)
                                }}
                              </div>
                            </div>
                            <div v-else>
                              <div style="color:#52C41A;font-weight:bold">
                                +{{ item1.beforeRightSubmissionNum }}
                              </div>
                              {{
                                Math.floor(item1.costTime / 60) +
                                  ':' +
                                  ((item1.costTime % 60) / 100)
                                    .toFixed(2)
                                    .slice(-2)
                              }}
                            </div>
                            <!-- <div>{{item1.beforeRightSubmissionNum}}</div>
                        {{Math.floor(item1.costTime/60) + ':'+(item1.costTime%60/100).toFixed(2).slice(-2)}} -->
                          </div>
                        </span>
                        <span
                          style="color:blue;cursor: pointer;"
                          v-if="
                            item1.problemId === item.oj_problem_id &&
                              contentMain.rule_type === 2
                          "
                        >
                          <!-- @click="searchProblem(item1)" -->
                          <div>{{ item1.score }}</div>
                          <div>{{ item1.cpuTime }}</div>
                        </span>
                        <span
                          v-if="
                            item1.problemId === item.oj_problem_id &&
                              contentMain.rule_type === 3
                          "
                        >
                          <!-- @click="searchProblem(item1)" -->
                          <div style="color:blue;cursor: pointer;">
                            {{ item1.score }}
                          </div>
                          <div>({{ item1.cpuTime }})ms</div>
                        </span>
                      </span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
              <div style="margin: 20px; text-align: right">
                <el-pagination
                  @current-change="handleCurrent1"
                  :current-page="page_no1"
                  :page-size="page_size1"
                  layout="total, prev, pager, next, jumper"
                  :total="total1"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="briefIntroduction_right">
          <ul>
            <!-- <li class="clearfix">
                    <div class="fl">比赛编号</div>
                    <div class="fr">{{contentMain.code}}</div>
                  </li> -->
            <li
              class="clearfix"
              style="border-bottom: 1px solid #F2F6FC;padding-bottom: 5px;"
            >
              <div class="fl">
                <svg
                  t="1700721440874"
                  class="icon"
                  viewBox="0 0 1041 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="7058"
                  width="16"
                  height="16"
                >
                  <path
                    d="M364.474576 503.322034H190.915254V104.135593l173.559322-86.779661v485.966102z"
                    fill="#7FABDA"
                    p-id="7059"
                  ></path>
                  <path
                    d="M850.440678 503.322034H676.881356V17.355932l173.559322 86.779661v399.186441z"
                    fill="#7FABDA"
                    p-id="7060"
                  ></path>
                  <path
                    d="M364.474576 17.355932h312.40678v485.966102H364.474576V17.355932z"
                    fill="#A2C9ED"
                    p-id="7061"
                  ></path>
                  <path
                    d="M34.711864 503.322034h485.966102v104.135593H34.711864v-104.135593z"
                    fill="#BFA380"
                    p-id="7062"
                  ></path>
                  <path
                    d="M520.677966 503.322034h485.966102v104.135593H520.677966v-104.135593z"
                    fill="#A58763"
                    p-id="7063"
                  ></path>
                  <path
                    d="M69.423729 607.457627h52.067796v416.542373H69.423729V607.457627zM919.864407 607.457627h52.067796v416.542373h-52.067796V607.457627zM312.40678 572.745763h-69.423729a17.355932 17.355932 0 1 1 0-34.711865h69.423729a17.355932 17.355932 0 1 1 0 34.711865M798.372881 572.745763h-69.423728a17.355932 17.355932 0 1 1 0-34.711865h69.423728a17.355932 17.355932 0 1 1 0 34.711865M1024 520.677966H17.355932a17.355932 17.355932 0 1 1 0-34.711864h1006.644068a17.355932 17.355932 0 1 1 0 34.711864"
                    fill="#553323"
                    p-id="7064"
                  ></path>
                  <path
                    d="M572.745763 34.711864h86.779661v86.779661L451.254237 485.966102h-69.423729v-86.779661L572.745763 34.711864"
                    fill="#C0E1F9"
                    p-id="7065"
                  ></path>
                </svg>
                <span style="margin-left: 10px;">举办方</span>
              </div>
              <div class="fr">
                {{ $route.query.sponsor }}
              </div>
            </li>
            <li class="clearfix">
              <div class="fl">比赛类型</div>
              <div class="fr">
                <el-tag size="mini" v-if="contentMain.rule_type === 1"
                  >ACM</el-tag
                >
                <el-tag size="mini" v-if="contentMain.rule_type === 2"
                  >OI</el-tag
                >
                <el-tag size="mini" v-if="contentMain.rule_type === 3"
                  >IOI</el-tag
                >
              </div>
            </li>
            <li class="clearfix">
              <div class="fl">开始时间</div>
              <div class="fr">
                <span style="color:#909399">{{ contentMain.start_date }}</span>
              </div>
            </li>
            <li class="clearfix">
              <div class="fl">结束时间</div>
              <div class="fr">
                <span style="color:#909399">{{ contentMain.end_date }}</span>
              </div>
            </li>
            <li class="clearfix">
              <div class="fl">比赛时长</div>
              <div class="fr">
                <span style="color:#909399">{{ contentMain.time }}</span>
              </div>
            </li>
            <!-- <li v-if="$route.query.sign_mode == 3">
              <el-button type="success" style="width:100%">需主办方邀请</el-button>
            </li> -->
            <li>
              <el-button
                type="primary"
                style="width:100%"
                v-if="this.tableData2.length === 0"
                @click="addUserContestSign"
                :disabled="isShowBTn"
                >报名</el-button
              >
              <div v-else>
                <div v-for="item in tableData2" :key="item.id">
                  <el-button
                    type="success"
                    style="width:100%"
                    v-if="item.check_state === 1"
                  >
                    <span v-if="isShowTime">
                      <span v-if="isShowEndTime">进行中</span>
                      <span v-else>已结束</span>
                    </span>
                    <span v-else>已通过</span>
                  </el-button>
                  <el-button
                    type="success"
                    style="width:100%"
                    v-if="item.check_state === 0"
                    >未通过</el-button
                  >
                  <el-button
                    type="success"
                    style="width:100%"
                    v-if="item.check_state === null"
                    >未审核</el-button
                  >
                </div>
              </div>
            </li>
            <li v-if="isShowTime" style="text-align: center;">
              <span v-if="isShowEndTime"
                ><span style="color: #BEC9DC;">距离比赛结束还有</span>
                <span style="font-weight: bold;">{{
                  countdownTime
                }}</span></span
              >
            </li>
            <li v-else style="text-align: center;">
              <span style="color: #BEC9DC;">距离比赛开始还有</span>
              <span style="font-weight: bold;">{{ countdownTime1 }}</span>
            </li>
          </ul>
        </div>

        <div
          class="left"
          style="margin-top:10px;background:white;border-radius: 5px;"
        >
          <div class="clearfix" style="padding-left:20px;padding-top:20px;">
            <div class="txt" style="font-weight:bold;">
              <svg
                style="float:left;"
                t="1658450998090"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="11846"
                width="25"
                height="25"
              >
                <path
                  d="M232.0384 648.06912l2.08896 0.8192 197.38624 63.16032 61.56288 213.1968a72.74496 72.74496 0 0 1-10.48576 62.01344 68.11648 68.11648 0 0 1-23.79776 20.76672c-9.4208 4.9152-19.74272 7.45472-30.26944 7.45472-26.2144 0-51.65056-8.76544-72.66304-25.02656a126.68928 126.68928 0 0 1-43.90912-65.20832l-79.872-277.17632z m649.216-574.6688c12.00128 0 23.51104 4.95616 31.98976 13.80352 8.47872 8.8064 13.27104 20.80768 13.27104 33.30048v706.56c0 12.4928-4.79232 24.45312-13.27104 33.30048a44.40064 44.40064 0 0 1-31.98976 13.80352c-12.04224 0-23.552-4.95616-32.03072-13.80352a48.128 48.128 0 0 1-13.27104-33.30048V120.50432c0-12.4928 4.79232-24.49408 13.27104-33.30048 8.47872-8.84736 19.98848-13.80352 32.03072-13.80352z m-90.5216 94.208v612.352l-588.5952-188.416v-235.52l588.5952-188.416zM156.8768 356.02432v235.52H111.616c-12.00128 0-23.51104-4.95616-31.98976-13.80352a48.08704 48.08704 0 0 1-13.27104-33.30048v-141.312c0-12.4928 4.75136-24.49408 13.27104-33.30048 8.47872-8.84736 19.98848-13.80352 31.98976-13.80352H156.8768z"
                  fill="#2E78DD"
                  p-id="11847"
                ></path>
              </svg>

              <span
                style="float:left;line-height:25px;margin-left:5px;font-size:16px;"
              >
                比赛公告
              </span>
            </div>
          </div>
          <div style="padding:20px;">
            <mavon-editor
              style="min-height: 50px "
              preview-background="#fff"
              v-model="contentMain.notic"
              defaultOpen="preview"
              :boxShadow="false"
              :editable="false"
              :subfield="false"
              :toolbarsFlag="false"
            ></mavon-editor>
            <!-- <span style="font-size:16px;">{{ $route.query.typetime }}</span> -->
          </div>
        </div>

        <div></div>
      </el-col>
    </el-row>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="80%">
      <div v-html="ojProblemInfo.description"></div>
      <el-table
        :data="tableData5"
        stripe
        style="width: 100%;margin-top:20px"
        :header-cell-style="{ color: '#909399' }"
      >
        <el-table-column label="语言">
          <template slot-scope="scope">
            <span v-if="scope.row.language === 0">C</span>
            <span v-if="scope.row.language === 1">C++</span>
            <span v-if="scope.row.language === 2">Python3</span>
          </template>
        </el-table-column>
        <el-table-column label="耗时">
          <template slot-scope="scope">
            <span v-if="scope.row.time_cost === null">0ms</span>
            <span v-else>{{ scope.row.time_cost }}ms</span>
          </template>
        </el-table-column>
        <el-table-column label="内存">
          <template slot-scope="scope">
            <span>{{ scope.row.memory_cost / 1024 }}kb</span>
          </template>
        </el-table-column>

        <el-table-column prop="created_time" label="提交时间">
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.result === -1">程序输出不正确</span>
            <span v-if="scope.row.result === 0">程序输出正确</span>
            <span v-if="scope.row.result === 1">超时</span>
            <span v-if="scope.row.result === 2">超时</span>
            <span v-if="scope.row.result === 3">内存超限</span>
            <span v-if="scope.row.result === 4">程序运行错误</span>
            <span v-if="scope.row.result === 5">系统错误</span>
            <span v-if="scope.row.result === -2">编译失败</span>
            <span v-if="scope.row.result === 6">等待测评</span>
            <span v-if="scope.row.result === 7">测评中</span>
            <span v-if="scope.row.result === 8">部分输出正确</span>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="得分"> </el-table-column>
      </el-table>
      <div>
        <code-mirror v-model="code"></code-mirror>
      </div>
      <div
        style="margin-top:20px"
        v-if="contentMain.rule_type === 1 ? false : true"
      >
        <ul style="overflow: hidden;">
          <li
            v-for="(item, index) in textInfo"
            :key="index"
            class="fl"
            style="width:40%"
          >
            <div class="box1 clearfix">
              <div class="fl" style="margin-right:20px">
                {{ '#' + (index + 1 + '') }}
              </div>
              <div class="fl">{{ item.real_time }}ms /</div>
              <div class="fl">{{ item.memory / 1024 }}kb /</div>
              <div class="fl">{{ item.cpu_time }}ms</div>

              <div class="fr">
                <div
                  v-if="item.result === 0"
                  class="el-icon-success"
                  style="color: #67C23A; font-size: 14px;"
                ></div>
                <div
                  v-else
                  class="el-icon-error"
                  style="color: #F56C6C; font-size: 14px;"
                ></div>
              </div>
              <div class="fr" style="margin-right:10px">{{ item.score }}分</div>
            </div>
          </li>
        </ul>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getProblemForContest,
  getOjContestSignInfo,
  addUserContestSign,
  getContestRankList,
  getOjSubmissionInfo,
  getOjProblemInfoById,
  getUserContestRank,
} from '@/api/educational.js'
import CodeMirror from '@/components/CodeMirror'
import moment from 'moment'

export default {
  components: {
    CodeMirror,
  },

  data() {
    return {
      isShowBTn: false,
      sign_state: false,
      isShow2: false,
      disabled1: false,
      disabled2: true,

      isShow: false,
      ojProblemInfo: {},
      problem_id: '',
      tableData5: [],
      code: '',
      submissionId: null,
      dialogVisible: false,
      curStartTime: '2022-10-16 08:00:00',
      day: '00',
      hour: '00',
      min: '00',
      second: '00',

      tableData2: [],
      contest_id: '',
      contentMain: {
        time: '',
      },
      tableData1: [],
      page_no1: 1,
      page_size1: 20,
      total1: 20,
      content: '',
      page_no: 1,
      page_size: 100,
      total: 20,
      gameId: '',
      activeName: 'first',
      tableData: [],
      tableData3: [],

      textInfo: [],
      textInfo1: [],
      textInfo2: [],
      is_md: true,
      timer: null,
      countdownTime: '',
      countdownTime1: '',
      isShowTime: true,
      isShowEndTime: false,
    }
  },
  watch: {},

  created() {
    console.log(this.$route.query.sign_state, 1111)
    if (
      this.$route.query.sign_state == 'false' ||
      this.$route.query.sign_state == false ||
      this.$route.query.typetime == '已结束'
    ) {
      console.log(123465, 1111)
      this.isShowBTn = true
    } else {
      console.log(456789, 1111)
      this.isShowBTn = false
    }
    console.log(this.$route.query.languages, 123465)

    if (this.$route.query.type === 'ganme') {
      this.activeName = this.$route.query.activeName
      this.isShow = this.$route.query.isShow
    }
    if (this.$route.query.typetime === '已结束') {
      this.isShow = true
    }
    this.contest_id = this.$route.query.id
    // let endTime = new Date(el.finishedTime.replace(/-/g, "/"))
    this.contentMain = JSON.parse(sessionStorage.getItem('matchDetails'))
    this.is_md = this.contentMain.is_md
    console.log(this.contentMain, 123456)
    this.gameId = this.contentMain.id
    console.log(this.gameId)

    let startTime = new Date(this.contentMain.start_date.replace(/-/g, '/')) // 开始时间
    let endTime = new Date(this.contentMain.end_date.replace(/-/g, '/')) // 结束时间
    let usedTime = endTime - startTime // 相差的毫秒数
    let days = Math.floor(usedTime / (24 * 3600 * 1000)) // 计算出天数
    let leavel = usedTime % (24 * 3600 * 1000) // 计算天数后剩余的时间
    let hours = Math.floor(leavel / (3600 * 1000)) // 计算剩余的小时数
    let leavel2 = leavel % (3600 * 1000) // 计算剩余小时后剩余的毫秒数
    let minutes = Math.floor(leavel2 / (60 * 1000)) // 计算剩余的分钟数
    // return days + '天' + hours + '时' + minutes + '分';
    console.log(
      days +
        '天' +
        hours +
        '时' +
        minutes +
        '分' +
        Math.floor((endTime - startTime) / 1000) +
        '秒'
    )
    this.contentMain.time = days + '天' + hours + '时' + minutes + '分'
    console.log(this.contentMain.time, 12545)
  },
  mounted() {
    const yy1 = new Date().getFullYear()
    const MM1 =
      new Date().getMonth() + 1 < 10
        ? '0' + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1
    const dd1 =
      new Date().getDate() < 10
        ? '0' + new Date().getDate()
        : new Date().getDate()
    const HH1 =
      new Date().getHours() < 10
        ? '0' + new Date().getHours()
        : new Date().getHours()
    const mm1 =
      new Date().getMinutes() < 10
        ? '0' + new Date().getMinutes()
        : new Date().getMinutes()
    const ss1 =
      new Date().getSeconds() < 10
        ? '0' + new Date().getSeconds()
        : new Date().getSeconds()
    // return yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
    let newTime1 =
      yy1 + '-' + MM1 + '-' + dd1 + ' ' + HH1 + ':' + mm1 + ':' + ss1
    if (this.$route.query.end_date < newTime1) {
      this.disabled2 = false
      this.isShow2 = true
    } else {
      this.disabled2 = true
      this.isShow2 = false
    }
    if (this.$route.query.end_date < newTime1) {
      this.disabled1 = true
    } else {
      this.disabled1 = false
    }
    this.getOjContestSignInfo()
    this.countTime()
    if (this.activeName === 'second') {
      this.contest_id = this.gameId
      this.getProblemForContest()

      // if (this.$route.query.rule_type === 1) {
      //   this.contest_id = this.$route.query.oj_contest_id
      //   // this.getContestRankList()
      //   this.getProblemForContest()

      // }
      // if (this.$route.query.rule_type === 3) {
      //   this.contest_id = this.$route.query.oj_contest_id
      //   // this.getContestRankList()
      //   this.getProblemForContest()

      // }
    }
    this.countDown()
    // setInterval(() => {
    //   this.countDown()
    // }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    countDown() {
      let endTime = new Date(this.contentMain.end_date.replace(/-/g, '/')) // 结束时间
      let startTime = new Date(this.contentMain.start_date.replace(/-/g, '/')) // 开始时间
      this.timer = setInterval(() => {
        let nowTime = moment()
          .locale('zh-cn')
          .format('YYYY-MM-DD HH:mm:ss') //当前时间
        let endTime1 = moment(endTime)
          .locale('zh-cn')
          .format('YYYY-MM-DD HH:mm:ss')
        console.log(endTime1)
        let x = moment(endTime).diff(moment(nowTime), 'seconds')
        var d = moment.duration(x, 'seconds')
        this.countdownTime =
          Math.floor(d.asDays()) +
          ' 天 ' +
          d.hours() +
          ' 时 ' +
          d.minutes() +
          ' 分 ' +
          d.seconds() +
          ' 秒 '
        let startTime1 = moment(startTime)
          .locale('zh-cn')
          .format('YYYY-MM-DD HH:mm:ss')
        console.log(startTime1)
        let x1 = moment(startTime).diff(moment(nowTime), 'seconds')
        var d1 = moment.duration(x1, 'seconds')
        this.countdownTime1 =
          Math.floor(d1.asDays()) +
          ' 天 ' +
          d1.hours() +
          ' 时 ' +
          d1.minutes() +
          ' 分 ' +
          d1.seconds() +
          ' 秒 '
        if (x < 0) {
          this.isShowEndTime = false
          clearInterval(this.timer)
          this.timer = null
        } else {
          this.isShowEndTime = true
        }
        if (x1 < 0) {
          // 小于0 表示比赛已经开始
          this.isShowTime = true
        } else {
          this.isShowTime = false
        }
      }, 1000)
    },

    formatRichText(html) {
      // eslint-disable-next-line no-unused-vars
      let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
        console.log(capture)
        match = match
          .replace(/style="[^"]+"/gi, '')
          .replace(/style='[^']+'/gi, '')
        match = match
          .replace(/width="[^"]+"/gi, '')
          .replace(/width='[^']+'/gi, '')
        match = match
          .replace(/height="[^"]+"/gi, '')
          .replace(/height='[^']+'/gi, '')
        return match
      })
      // eslint-disable-next-line no-unused-vars
      newContent = newContent.replace(/style="[^"]+"/gi, function(
        match,
        capture
      ) {
        console.log(capture)
        match = match
          .replace(/width:[^;]+;/gi, 'max-width:100%;')
          .replace(/width:[^;]+;/gi, 'max-width:100%;')
        return match
      })
      newContent = newContent.replace(/<br[^>]*\/>/gi, '')
      // eslint-disable-next-line no-useless-escape
      newContent = newContent.replace(
        /<img/gi,
        '<img style="max-width:100%;height:auto;display:block;margin-top:0;margin-bottom:0;"'
      )
      return newContent
    },
    searchProblem(item1) {
      console.log(item1)
      this.submissionId = item1.submissionId
      this.problem_id = item1.problemId
      this.getOjProblemInfoById()
      this.getOjSubmissionInfo()

      this.$nextTick(() => {
        this.dialogVisible = true
      })
    },
    getOjProblemInfoById() {
      getOjProblemInfoById({
        problem_id: this.problem_id,
      }).then((res) => {
        console.log(res)
        this.ojProblemInfo = res.ojProblemInfo
        this.textInfo1 = JSON.parse(res.ojProblemInfo.test_case_score)
        console.log(this.textInfo1, 123465)
        console.log(this.textInfo2, 123465)
        var obj = this.textInfo1.map((item, index) => {
          return { ...item, ...this.textInfo2[index] }
        })
        this.textInfo = obj
        console.log(this.textInfo, 21122455)
      })
    },
    getOjSubmissionInfo() {
      getOjSubmissionInfo({
        submission_id: this.submissionId,
      }).then((res) => {
        this.code = res.submission.code
        this.textInfo2 = JSON.parse(res.submission.testcases_info)

        this.tableData5 = []
        this.tableData5.push(res.submission)
        console.log(res, 222222222222)
      })
    },
    handleClick(val) {
      console.log(val, 124545)
      if (val.index == '1') {
        this.getProblemForContest()
      }
      if (val.index === '2') {
        const yy = new Date().getFullYear()
        const MM =
          new Date().getMonth() + 1 < 10
            ? '0' + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1
        const dd =
          new Date().getDate() < 10
            ? '0' + new Date().getDate()
            : new Date().getDate()
        const HH =
          new Date().getHours() < 10
            ? '0' + new Date().getHours()
            : new Date().getHours()
        const mm =
          new Date().getMinutes() < 10
            ? '0' + new Date().getMinutes()
            : new Date().getMinutes()
        const ss =
          new Date().getSeconds() < 10
            ? '0' + new Date().getSeconds()
            : new Date().getSeconds()
        // return yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
        let newTime = yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
        console.log(newTime, 12456)
        console.log(this.$route.query.end_date, 12456)
        // this.$route.query.end_date <= newTime

        if (this.$route.query.rule_type1 == 2) {
          if (this.$route.query.end_date <= newTime) {
            this.getContestRankList()
            this.getProblemForContest()
          }
        } else if (this.$route.query.rule_type1 == 3) {
          this.getContestRankList()
          this.getProblemForContest()
        } else if (this.$route.query.rule_type1 == 1) {
          this.getContestRankList()
          this.getProblemForContest()
        }
      }
    },
    getContestRankList() {
      getContestRankList({
        contest_id: this.contest_id,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log(res, 12456)
        this.tableData1 = res.contestRankList
        this.total1 = res.total
      })
    },
    countTime() {
      this.curStartTime = this.contentMain.start_date.replace(/-/g, '/')
      // 获取当前时间
      let date = new Date()
      let now = date.getTime()
      // 设置截止时间
      let endDate = new Date(this.curStartTime) // this.curStartTime需要倒计时的日期
      let end = endDate.getTime()
      // 时间差
      let leftTime = end - now
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // 天
        let day = Math.floor(leftTime / 1000 / 60 / 60 / 24)
        // 三元表达式判断不满10前面加0
        this.day = day < 10 ? '0' + day : day
        // 时
        let h = Math.floor((leftTime / 1000 / 60 / 60) % 24)
        this.hour = h < 10 ? '0' + h : h
        // 分
        let m = Math.floor((leftTime / 1000 / 60) % 60)
        this.min = m < 10 ? '0' + m : m
        // 秒
        let s = Math.floor((leftTime / 1000) % 60)
        this.second = s < 10 ? '0' + s : s
      } else {
        this.day = '00'
        this.hour = '00'
        this.min = '00'
        this.second = '00'
      }
      // 等于0的时候不调用
      if (
        Number(this.hour) === 0 &&
        Number(this.day) === 0 &&
        Number(this.min) === 0 &&
        Number(this.second) === 0
      ) {
        return
      } else {
        // 递归每秒调用countTime方法，显示动态时间效果,
        setTimeout(this.countTime, 1000)
      }
    },

    addUserContestSign() {
      addUserContestSign({
        contest_id: this.gameId,
      }).then((res) => {
        console.log(res)
        this.$message.success('报名成功')
        this.getOjContestSignInfo()
      })
    },
    getOjContestSignInfo() {
      getOjContestSignInfo({
        contest_id: this.gameId,
      }).then((res) => {
        console.log(res, 111)
        this.tableData2 = res.contestSignList
        // if()
        this.tableData2.map((item) => {
          console.log(item.check_state)
          if (item.check_state === 1) {
            const yy = new Date().getFullYear()
            const MM =
              new Date().getMonth() + 1 < 10
                ? '0' + (new Date().getMonth() + 1)
                : new Date().getMonth() + 1
            const dd =
              new Date().getDate() < 10
                ? '0' + new Date().getDate()
                : new Date().getDate()
            const HH =
              new Date().getHours() < 10
                ? '0' + new Date().getHours()
                : new Date().getHours()
            const mm =
              new Date().getMinutes() < 10
                ? '0' + new Date().getMinutes()
                : new Date().getMinutes()
            const ss =
              new Date().getSeconds() < 10
                ? '0' + new Date().getSeconds()
                : new Date().getSeconds()
            // return yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
            let newTime =
              yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
            if (
              this.$route.query.start_date < newTime &&
              this.$route.query.end_date > newTime
            ) {
              this.isShow = true
            }
          }
        })
      })
    },
    goNext(row) {
      console.log(row.id)
      console.log(row.ojProblemInfo)

      const yy = new Date().getFullYear()
      const MM =
        new Date().getMonth() + 1 < 10
          ? '0' + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1
      const dd =
        new Date().getDate() < 10
          ? '0' + new Date().getDate()
          : new Date().getDate()
      const HH =
        new Date().getHours() < 10
          ? '0' + new Date().getHours()
          : new Date().getHours()
      const mm =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      const ss =
        new Date().getSeconds() < 10
          ? '0' + new Date().getSeconds()
          : new Date().getSeconds()
      // return yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
      let newTime = yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss

      if (this.$route.query.end_date < newTime) {
        this.$router.push({
          name: 'detailsMatch',
          query: {
            oj_contest_id: this.gameId,

            rule_type1: this.$route.query.rule_type1,
            id: row.oj_problem_id,
            activeName: 'second',
            isShow: this.isShow,
            title: this.$route.query.title,
            type1: 'game1',
            typeNext: this.$route.query.typeNext,
            type: this.$route.query.type,
            languages: this.$route.query.languages,
            typetime: this.$route.query.typetime,
            end_date: this.$route.query.end_date,
          },
        })
      } else {
        this.$router.push({
          name: 'detailsMatch',
          query: {
            rule_type1: this.$route.query.rule_type1,

            id: row.oj_problem_id,
            oj_contest_id: this.gameId,
            rule_type: this.contentMain.rule_type,
            activeName: 'second',
            isShow: this.isShow,
            title: this.$route.query.title,
            type1: 'game1',
            typeNext: this.$route.query.typeNext,

            languages: this.$route.query.languages,
            end_date: this.$route.query.end_date,
            typetime: this.$route.query.typetime,
          },
        })
      }
    },
    goNext1(row) {
      console.log(row.id)
      console.log(row.ojProblemInfo)

      const yy = new Date().getFullYear()
      const MM =
        new Date().getMonth() + 1 < 10
          ? '0' + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1
      const dd =
        new Date().getDate() < 10
          ? '0' + new Date().getDate()
          : new Date().getDate()
      const HH =
        new Date().getHours() < 10
          ? '0' + new Date().getHours()
          : new Date().getHours()
      const mm =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      const ss =
        new Date().getSeconds() < 10
          ? '0' + new Date().getSeconds()
          : new Date().getSeconds()
      // return yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
      let newTime = yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss

      if (this.$route.query.end_date < newTime) {
        // this.disabled2 = false

        this.$router.push({
          name: 'questionBankDetails',
          query: {
            id: row.oj_problem_id,
            activeName: 'second',
            isShow: this.isShow,
            title: this.$route.query.title,
            type1: 'game1',
            languages: this.$route.query.languages,
            end_date: this.$route.query.end_date,
          },
        })
      }
    },
    getProblemForContest() {
      getProblemForContest({
        constest_id: this.gameId,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res)
        this.tableData = res.contestProblemRelationList
        // this.tableData3 = res.contestProblemRelationList
        this.total = res.total
        let arr1 = []
        arr1 = res.contestProblemRelationList
        getUserContestRank({
          contest_id: this.gameId,
        }).then((res) => {
          let arr2 = []
          res.contestRankList.map((item1) => {
            arr2 = JSON.parse(item1.submission_info)
          })
          arr1.map((item) => {
            arr2.map((item1) => {
              if (item1.problemId === item.oj_problem_id) {
                item.stats = '1'
              }
            })
          })
          console.log(arr1, 123456)
          this.tableData3 = arr1
        })
      })
    },

    goback() {
      if (this.$route.query.typeNext == 'My') {
        this.$router.push({
          name: 'match',
        })
        console.log(1245)
      } else {
        this.$router.push({
          name: 'MyMatch',
        })
        console.log(78945)
      }
      // if (this.$route.query.type == 'MyMatch') {
      //   this.$router.push({
      //     name: "MyMatch",
      //   })
      // } else if (this.$route.query.type == 'ganme') {
      //   this.$router.push({
      //     name: 'match'
      //   })
      // }
      // else {
      //   this.$router.push({
      //     name: 'MyMatch'
      //   })
      // }
      // this.$router.go(-1)
    },
    handleCurrent(val) {
      this.page_no = val
      this.getProblemForContest()
    },
    handleCurrent1(val) {
      this.page_no1 = val
      this.getContestRankList()
    },
  },
}
</script>

<style lang="scss" scoped>
.subjectDetails {
  height: 100%;
  width: 100%;

  .bisai_desc {
    min-height: calc(100vh - 238px);
  }

  .timu_desc {
    min-height: calc(100vh - 180px);
  }
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.main {
  margin: 10px;
  background: 10px;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.briefIntroduction_right {
  padding: 20px;
  padding-top: 0px;
  background: white;
  border-radius: 5px;
  overflow: hidden;
}

.briefIntroduction_right li {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 500;
}

.briefIntroduction_righ_bottom {
  padding: 20px;
  background: #f9f9f9;
  border-radius: 5px;
  overflow: hidden;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: '';
  display: block;
  visibility: hidden;
  clear: both;
}

::v-deep .el-drawer__header > :first-child {
  outline: none;
}

.box1 {
  border: 1px solid #1fb26e;
  padding: 15px;
  // float: left;
}
</style>
